<template>
  <v-col cols="12" lg="3">
    <v-card color="#26c6da"
    dark>
      <v-card-text class="text-center">
        <v-row>
          <v-col cols="4">
            <div class="my-2">
              <v-icon large color="blue darken-2">{{ icon }}</v-icon>
            </div>
          </v-col>
          <v-col cols="8 text-left px-0">
            <h4
              class="mt-2 title white--text text--darken-2 font-weight-regular"
            >
              {{ value }}
              <h6 class="subtitle-2 font-weight-light">
                {{ label }}
              </h6>
            </h4>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    icon: {
      type: String
    },
    label: { 
      type: String
    }
  },
};
</script>
